import BlockComponent from "../BlockComponent";

import React from "react";
import Valeur from "./Valeur";

export type ValeurProps = {
  titre: string;
  image: string;
  description: string[];
};

const valeursList: Array<ValeurProps> = [
  {
    titre: "Accomplissement",
    image: "/accomplissement.svg",
    description: ["Bonheur", "Communication", "Equilibre", "Responsabilisation"],
  },
  {
    titre: "Connaissances",
    image: "/connaissances.svg",
    description: ["Education", "Créativité", "Divertissement", "Professionnalisation"],
  },
  {
    titre: "Perfection",
    image: "/perfection.svg",
    description: ["Dépassement de soi", "Excellence", "Passion", "Persévérance"],
  },
  {
    titre: "Respect",
    image: "/respect.svg",
    description: ["Altruisme", "Diversité", "Loyauté", "Partage"],
  },
];

const Valeurs: React.FC = () => {
  return (
    <BlockComponent titre="Nos valeurs">
      <div id="grid-valeurs" className="grid w-full gap-4 md:grid-cols-2 lg:grid-cols-4">
        {valeursList.map((valeur, key) => (
          <Valeur key={key} titre={valeur.titre} image={valeur.image} description={valeur.description}></Valeur>
        ))}
      </div>
    </BlockComponent>
  );
};

export default Valeurs;
